import React, { useState } from "react";
import PropTypes from "prop-types";
import { IconButton, Typography } from "@mui/material";

//import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
//import DownloadDoneOutlinedIcon from "@mui/icons-material/DownloadDoneOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import "./Asset.css";
import { ChangeableGoodIcon } from "./ChangeableGoodIcon";

export function Assessment({ viewCnt, goodCnt, isGood }) {
  const [selfIsGood, SetSelfIsGood] = useState(isGood);

  return (
    <div>
      <label htmlFor="icon-button-file">
        <IconButton aria-label="view" component="span">
          <VisibilityOutlinedIcon />
          <Typography>{viewCnt}</Typography>
        </IconButton>
      </label>
      <label htmlFor="icon-button-file">
        <IconButton
          color="primary"
          aria-label="good"
          component="span"
          onClick={() => {
            SetSelfIsGood(!selfIsGood);
            // call createGoodAsset

            // when success
            // update local my good asset

            // when fail
            // reverse selfIsGood and good button icon
          }}
        >
          <ChangeableGoodIcon isGood={selfIsGood} />
          <Typography>{goodCnt}</Typography>
        </IconButton>
      </label>
    </div>
  );
}

Assessment.propTypes = {
  viewCnt: PropTypes.string,
  goodCnt: PropTypes.string,
  isGood: PropTypes.bool,
};
